import * as R from 'ramda'
import { Brands } from '../actions'

const reducer = (state = {}, action) =>
  R.cond([
    [R.equals(Brands.TYPE.get_brands), R.always(action.payload)],
    [R.T, R.always(state)],
  ])(action.type)

export default reducer
